import React, { createContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerURL } from '../serverURL';

const AuthkeyCheck = createContext(null);
export const useAuthCheck = () => React.useContext(AuthkeyCheck);

class AuthkeyCheckProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authKeyValidate: true,
      authValidateMsg: '',
      isLoading: true,
      ApiCheckFlag: '',
      isAuthenticated: false,
      isCompanyAuthenticated: false,
      isAdminAuthenticated: false,
      isCompanySessionAuthenticated: false,
      isAdminSessionAuthenticated: false,
      isSessionAuthenticated: false,
      candidateAuthKey: localStorage.getItem('authKey'), // Set initial state
      companyAuthKey: localStorage.getItem('auth_key'),
      adminAuthKey: localStorage.getItem('admin_auth_key'),
      validateAuth: sessionStorage.getItem('validateAuth'),
      candidateAuthKeyValid: Number(localStorage.getItem('candidateAuthKeyValid')),
    };
  }

  updateAuthKeys = () => {
    // Check and set keys only if they differ from the current state
    const candidateAuthKeyValid = Number(localStorage.getItem('candidateAuthKeyValid'));
    const candidateAuthKey = localStorage.getItem('authKey');
    const companyAuthKey = localStorage.getItem('auth_key');
    const adminAuthKey = localStorage.getItem('admin_auth_key');    

    if (
      candidateAuthKeyValid !== this.state.candidateAuthKeyValid ||
      candidateAuthKey !== this.state.candidateAuthKey ||
      companyAuthKey !== this.state.companyAuthKey ||
      adminAuthKey !== this.state.adminAuthKey
    ) {
      this.setState({ candidateAuthKeyValid, candidateAuthKey, companyAuthKey, adminAuthKey });
    }
  };

  //When login to auth check
  triggerAuthCheck = async (data_auth_key) => {
    const { location } = this.props;    
    if (location.pathname.startsWith('/company')) {      
      localStorage.setItem("auth_key", data_auth_key);     
    }
    else if (location.pathname.startsWith('/admin')) {
      localStorage.setItem("admin_auth_key", data_auth_key);
    }
    else if (location.pathname.startsWith('/') || location.pathname.startsWith('/login')) {
      localStorage.setItem("authKey", data_auth_key);
    }
    return await this.checkAuthKey(data_auth_key);
  };  

  componentDidMount = async () => {
    await this.updateAuthKeys(); // Update keys on route change
    await this.checkAuthKey(null);
  };

  //Every path change to call the function
  componentDidUpdate = async (prevProps) => {
    if ((this.props.location.pathname !== prevProps.location.pathname) && !this.props.location.pathname.startsWith('/basic-details')) {
      await this.updateAuthKeys();
      await this.checkAuthKey(null);
    }
  };

  checkAuthKey = async (data_auth_key) => {
    const { location } = await this.props;
    const { companyAuthKey, adminAuthKey, candidateAuthKey, candidateAuthKeyValid } = await this.state;
    // eslint-disable-next-line no-unused-vars
    let apiUrl = '';
    let response;
    let data;

    try {
      if (location.pathname.startsWith('/company') && (data_auth_key ? data_auth_key : companyAuthKey)) {
        response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}companies/check_authKey`, {
          method: "GET", 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${data_auth_key ? data_auth_key : companyAuthKey}`,
          },
        });
        this.setState({ ApiCheckFlag: 'Company' });
      } else if (location.pathname.startsWith('/admin') && (data_auth_key ? data_auth_key : adminAuthKey)) {
        response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}agent/check_authKey`, {
          method: "GET", 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${data_auth_key ? data_auth_key : adminAuthKey}`,
          },
        });
        this.setState({ ApiCheckFlag: 'Admin' });
      } else if (data_auth_key ? data_auth_key : candidateAuthKey && candidateAuthKeyValid === 1) {
        response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}candidates/check_authKey`, {
          method: "GET", 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${data_auth_key ? data_auth_key : candidateAuthKey}`,
          },
        });
        this.setState({ ApiCheckFlag: 'Candidate' });
      }
      
      data = await response.json();
      if (response.ok) {
        sessionStorage.setItem('validateAuth', true);

        if (data?.company_user_details?.company_uid) {
          localStorage.setItem("company_uid", data.company_user_details.company_uid);
        }

        if (typeof data?.company_user_details?.company_agent_approval_status !== 'undefined') {
          localStorage.setItem('company_agent_approval_status', String(data.company_user_details.company_agent_approval_status));
        }
        
        if (typeof data?.company_user_details?.register_expired !== 'undefined') {
          localStorage.setItem('register_expired', String(data.company_user_details.register_expired));
        }

        if (typeof data?.company_user_details?.initial_job_post_published !== 'undefined') {
          localStorage.setItem('initial_job_post_published', String(data.company_user_details.initial_job_post_published));
        }

        // Store candidate profile/skill registration status and update progress flags if present
        if (data?.candidate_details) {
          if (typeof data.candidate_details.is_profile_registered !== 'undefined') {
            localStorage.setItem('is_profile_registered', String(data.candidate_details.is_profile_registered));
          }
          if (typeof data.candidate_details.is_skill_registered !== 'undefined') {
            localStorage.setItem('is_skill_registered', String(data.candidate_details.is_skill_registered));
          }
          // Store candidate progress flags
          if (typeof data.candidate_details.is_candidate_basic_details_updated !== 'undefined') {
            localStorage.setItem('is_candidate_basic_details_updated', String(data.candidate_details.is_candidate_basic_details_updated));
          }
          if (typeof data.candidate_details.is_candidate_experience_details_updated !== 'undefined') {
            localStorage.setItem('is_candidate_experience_details_updated', String(data.candidate_details.is_candidate_experience_details_updated));
          }
          if (typeof data.candidate_details.is_candidate_desired_info_updated !== 'undefined') {
            localStorage.setItem('is_candidate_desired_info_updated', String(data.candidate_details.is_candidate_desired_info_updated));
          }
          if (typeof data.candidate_details.is_candidate_skill_details_updated !== 'undefined') {
            localStorage.setItem('is_candidate_skill_details_updated', String(data.candidate_details.is_candidate_skill_details_updated));
          }
        }

        this.setState({
          authKeyValidate: true,
          authValidateMsg: data.message || 'Authenticated successfully',
          isLoading: false,
          isCompanyAuthenticated: this.state.ApiCheckFlag === 'Company',
          isAdminAuthenticated: this.state.ApiCheckFlag === 'Admin',
          isAuthenticated: this.state.ApiCheckFlag === 'Candidate',
          isCompanySessionAuthenticated: this.state.ApiCheckFlag === 'Company',
          isAdminSessionAuthenticated: this.state.ApiCheckFlag === 'Admin',
          isSessionAuthenticated: this.state.ApiCheckFlag === 'Candidate',
        });
        return true;
      } else {
        throw new Error(data?.error?.message);
      }
    } catch (error) {
      if (response?.status === 440) {
        sessionStorage.setItem('validateAuth', false);
        this.setState({
          authKeyValidate: false,
          authValidateMsg: this.state.ApiCheckFlag === 'Company' ? '/company/login' : this.state.ApiCheckFlag === 'Admin' ? '/admin/auth/admin-login' : this.state.ApiCheckFlag === 'Candidate' ? '/login' : '/',
          isLoading: false,
          isCompanyAuthenticated: false,
          isAdminAuthenticated: false,
          isAuthenticated: false,
          isCompanySessionAuthenticated: false,
          isAdminSessionAuthenticated: false,
          isSessionAuthenticated: false,
        });
        return false;
      }      
    }
  };

  render() {
    const {
      authKeyValidate,
      authValidateMsg,
      isAuthenticated,
      isCompanyAuthenticated,
      isAdminAuthenticated,
      isSessionAuthenticated,
      isCompanySessionAuthenticated,
      isAdminSessionAuthenticated,
      isLoading,
      companyAuthKey,
      adminAuthKey
    } = this.state;

    return (
      <AuthkeyCheck.Provider
        value={{
          triggerAuthCheck: this.triggerAuthCheck,
          authKeyValidate,
          authValidateMsg,
          isAuthenticated,
          isCompanyAuthenticated,
          isAdminAuthenticated,
          isSessionAuthenticated,
          isCompanySessionAuthenticated,
          isAdminSessionAuthenticated,
          isLoading,
          companyAuthKey,
          adminAuthKey
        }}
      >
        {this.props.children}
      </AuthkeyCheck.Provider>
    );
  }
}

// Wrapper component to provide location and navigation
function AuthkeyCheckProviderWrapper(props) {
  const location = useLocation();
  const navigate = useNavigate();

  return <AuthkeyCheckProvider {...props} location={location} navigate={navigate} />;
}

export default AuthkeyCheckProviderWrapper;
